const FetchLoader = () => {
  return (
    <div className="loaderDiv">
      <span class="fetchLoader"></span>
    </div>
  );
};

export default FetchLoader;
